import { searchFields } from '../utils/fields';

//必要なフィールドだけを動的に取得する関数
export const getFields = (fieldsToInclude) => {
  return searchFields.filter(field => fieldsToInclude.includes(field.name));
};
/*
// 入力フィールドの変更
export const handleChange = (key, value, setDataset) => {
    setDataset((prevData) => ({
        ...prevData,
        [key]: value,
    }));
};

// 編集ボタンクリック時にそのフィールドを編集可能にする
export const handleEditClick = (key, setEditableFields) => {
    setEditableFields((prevState) => ({
        ...prevState,
        [key]: true, // 編集を有効にする
    }));
};*/
/*
export const handleChange = (e, data, setData, itemsKey, index, field) => {
  const { type, value, checked } = e.target;

  const newValue = type === 'checkbox' ? checked : value;

  if (itemsKey) {
    // `items` の場合、特定のアイテムを更新
    const newItems = [...data[itemsKey]];
    newItems[index] = {
      ...newItems[index],
      [field]: newValue, // ここでfield（'quantity'）を使って更新
    };
    setData({
      ...data,
      [itemsKey]: newItems,
    });
  } else {
    // 一般的なフィールドの場合
    setData({
      ...data,
      [e.target.name]: newValue,
    });
  }
};
*/
/*
export const handleEditClick = (e, setIsEditMode) => {
  // 編集ボタンをクリックしたら編集モードを切り替え
  setIsEditMode(true);
  // クリックしたボタンの親要素を取得
  const parentElement = e.target.closest('.edit-container');  // 親要素を取得

  // 親要素が見つからなかった場合は処理を終了
  if (!parentElement) return;

  // 親要素内の全ての input, textarea, select 要素を取得
  const elements = parentElement.querySelectorAll('input, textarea, select');  // input, textarea, select を対象に

  // 編集ボタンを取得
  const editButton = parentElement.querySelector('button.edit-button'); // 編集ボタンを取得

  if (editButton) {
    // ボタンのテキストを空文字に変更
    editButton.textContent = ''; // 編集ボタンのテキストを空文字にする
  }

  // すべての input, textarea, select 要素 の 'disabled' 状態を切り替え
  elements.forEach(element => {
    // 'exclude-checkbox' クラスを持っているチェックボックスを除外
    if (element.type === 'checkbox' && element.classList.contains('exclude')) {
      return; // このcheckboxを除外するため、何もしないで次へ進む
    }

    // チェックボックス以外、または除外対象のcheckboxについて処理
    if (element.disabled) {
      element.disabled = false; // disabledを解除
      element.classList.remove('disabled'); // 'disabled'クラスを取り除く
    } else {
      element.disabled = true; // disabledを設定
      element.classList.add('disabled');  // 'disabled'クラスを追加
    }
  });
};
*/
/*合計金額 */


/*合計金額 */
/*
// 1アイテムのサブトータルを計算
export function calculateItemSubtotal(item) {
  const subtotal = (item.selling_price ?? 0) * (item.quantity ?? 0);
  const subtotal_including_tax = (item.selling_price_including_tax ?? 0) * (item.quantity ?? 0);
  return { subtotal, subtotal_including_tax };
}

// 全アイテムの合計金額を計算
export function calculateTotalAmount(items) {
  const total_amount = items.reduce((sum, item) => sum + (item.subtotal ?? 0), 0);
  const total_amount_including_tax = items.reduce((sum, item) => sum + (item.subtotal_including_tax ?? 0), 0);
  return { total_amount, total_amount_including_tax };
}
*/
//税込価格
export const calculateSellingPriceIncludingTax = (sellingPrice, taxRate) => {
  const rate = taxRate ?? 0;
  return Math.floor(sellingPrice * (1 + rate / 100));
};
/*
export function calculateItemSubtotal(item) {
  const price = Number(item.selling_price ?? item.purchase_price) || 0;
  const quantity = Number(item.quantity) || 0;
  const taxRate = Number(item.tax_rate) || 0; // 例: 10 = 10%

  const subtotal = price * quantity;
  const subtotal_including_tax = Math.floor(subtotal * (1 + taxRate / 100));

  return { subtotal, subtotal_including_tax };
}
*/
export function calculateItemSubtotal({ price, quantity, tax_rate }) {
  const subtotal = price * quantity;
  const subtotal_including_tax =
    Math.floor(subtotal * (1 + tax_rate / 100));

  return { subtotal, subtotal_including_tax };
}

// 全アイテムの合計金額を計算
export function calculateTotalAmount(items = []) {
  const total_amount = items.reduce(
    (sum, item) => sum + (Number(item.subtotal) || 0),
    0
  );

  const total_amount_including_tax = items.reduce(
    (sum, item) => sum + (Number(item.subtotal_including_tax) || 0),
    0
  );

  return { total_amount, total_amount_including_tax };
}